import cred_others from '../../assets/cred_others.png'
import fluxo_act from '../../assets/credenciamento_ACTs_detalhado.png'
import fluxo_psc from '../../assets/credenciamento_PSCs_detalhado.png'
import './ajuda.css';

export default function Ajuda(){
    return(
        <div className='ajuda'>
            <h1>Autoridades de Carimbo de Tempo e Prestadores de Serviço de Confiança</h1>
            <p>As situações (status) constantes na aplicação Fila estão atreladas
            diretamente aos processos de credenciamento de entidades, que se dão com base no DOC-ICP-03.</p>
            <p>Os processos de credenciamento de AC's, ACT's e PSC's; podem ser
            definidos em 6 grandes etapas, que acontecem em sequência, respectivamente:</p>
            <img src={cred_others}></img>
            Para maiores detalhes, acesse o fluxo completo de<a href={fluxo_act}> Autoridades de Carimbo de Tempo</a> e
            <a href={fluxo_psc}> Prestadores de Serviço de Confiança</a>.
            <hr/>
            <h2>Estados</h2>
            <ul>
                <h5 className='protocolo'>Protocolo</h5>
                <p>Início do pedido de credenciamento, onde ocorre a abertura do processo e anexação da documentação recebida a este.</p>
                <h5 className='analisetec'>Análise Técnica</h5>
                <p>Etapa na qual serão analisados os requisitos técnicos e fiscais e as práticas de certificação digital; podendo haver geração
                de pendências, caso a entidade não atenda às exigências.*</p>
                <h5 className='despachonot'>Despacho de Notificação</h5>
                <p>Etapa na qual as entidades são notificadas do deferimento ou do indeferimento das solicitações. No caso de credenciamento
                de AC's, essa etapa representa a análise da documentação final solicitada para o credenciamento.</p>
                <h5 className='analisedoc'>Análise Documental</h5>
                <p>Etapa do Processo onde ocorrerá a análise da documentação recebida; podendo haver geração de pendências, caso a 
                documentação entregue não esteja em conformidade, ou seja insuficiente.*</p>
                <h5 className='relatorio'>Relatório</h5>
                <p>Nessa etapa, serão expressos os resultados e a avaliação decorrente dos processos anteriores de Análise Documental e
                Análise Técnica, constando o parecer de deferimento ou indeferimento pelos auditores.</p>
                <h5 className='despachocred'>Despacho de Credenciamento</h5>
                <p>Etapa na qual se aguarda o despacho decisório de deferimento da entidade candidata a credenciamento. Após o despacho, 
                serão requisitados os últimos documentos para execução dos trâmites finais para Credenciamento da entidade, este que será 
                publicado no Diário Oficial da União, e consequentemente a entidade será vinculada à ICP-Brasil.</p>
            </ul><br/>
            <p>*Nas etapas sujeitas a geração de pendências, caso estas não sejam solucionadas dentro dos prazos estipulados no DOC-ICP-03,
            os processos relativos ao credenciamento das entidades estão passíveis a serem arquivados.</p>
        </div>
    )
}